import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Col, Row, Label, Grid, Button, Panel, FormGroup, ControlLabel, Checkbox } from 'react-bootstrap';
import Select from 'react-select';

import { DashboardMap } from './DashboardMap';
import { AddOnsDataManagerCommand } from '../../addOns/commands/AddOnsCommand';
import { PathAPI } from '../../../api/datamanager/PathAPI';
import { LineAPI } from '../../../api/datamanager/LineAPI';
import { StopAPI } from '../../../api/datamanager/StopAPI';
import { TripAPI } from '../../../api/datamanager/TripAPI';
import { PathStopAPI } from '../../../api/datamanager/PathStopAPI';
import { LoadingSpinner } from '../../LoadingSpinner';
import { HandleMessage } from '../../HandleMessage';
import { TitleRow } from '../../TitleRow';
import { EditionSelector } from '../../EditionSelector';

export class Dashboard extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            activeStops: [],
            activePaths: [],

            draftStops: [],
            draftPaths: [],

            availableActiveStops: [],
            availableActivePaths: [],
            availableDraftStops: [],
            availableDraftPaths: [],


            activeMapStops: [],
            activeMapPaths: [],

            activeStopsCount: 0,
            activePathsCount: 0,
            activeLinesCount: 0,
            activeTripsCount: 0,

            availablePathsActive: [],
            availablePathsDraft: [],

            activeLines: [],
            selectedActiveLines: [],
            selectedActivePaths: [],

            draftLines: [],
            selectedDraftLines: [],
            selectedDraftPaths: [],

            showStopsActive: true,
            showStopsDraft: true,

            loadingActiveLines: true,
            loadingActiveStops: true,
            loadingActivePaths: true,
            loadingActiveTrips: true,

            draftMapStops: [],
            draftMapPaths: [],
            draftPathStops: [],

            draftStopsCount: 0,
            draftPathsCount: 0,
            draftLinesCount: 0,
            draftTripsCount: 0,

            loadingDraftLines: true,
            loadingDraftStops: true,
            loadingDraftPaths: true,
            loadingDraftTrips: true,
            
            isActiveNetwork: true,

            alertTitle: "",
            alertMessage: "",
            icon: "",
            alertStyle: "",
            showErrorModal: false,

            addOns: [],

            commands: {
                addOns: new AddOnsDataManagerCommand()
            },

            actions: {
                isExecutingAddOn: false,
            },
            render: {
                addOn: "",
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            }
        };
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);

        // Add as observer
        this.context.addEditionObserver(this);
        this.getAddOns();
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    updateNetwork() {
        this.setState({
            loadingActiveLines: true,
            loadingActivePaths: true,
            loadingActiveStops: true
        }, () => {
            let selectedProvider = '';
            if (this.context.selectedProvider !== undefined) {
                selectedProvider = this.context.selectedProvider.split(':')[0];
            }

            this.countLines(this.context.edition, selectedProvider);
            this.getLines(this.context.edition, selectedProvider);
            this.getPaths(this.context.edition, selectedProvider);
            this.getStops(this.context.edition, selectedProvider);
        });
    }

    updateDraftNetwork() {
        this.setState({
            loadingDraftLines: true,
            loadingDraftPaths: true,
            loadingDraftStops: true
        }, () => {
            let selectedProvider = '';
            if (this.context.selectedProvider !== undefined) {
                selectedProvider = this.context.selectedProvider.split(':')[0];
            }

            this.countLinesDraft(this.context.edition, selectedProvider);
            this.getLinesDraft(this.context.edition, selectedProvider);
            this.getPathsDraft(this.context.edition, selectedProvider);
            this.getStopsDraft(this.context.edition, selectedProvider);
        });
    }

    updatePlanning() {
        this.setState({
            loadingActiveTrips: true
        }, () => {
            let selectedProvider = '';
            if (this.context.selectedProvider !== undefined) {
                selectedProvider = this.context.selectedProvider.split(':')[0];
            }

            this.countTrips(this.context.edition, selectedProvider);
        });
    }

    updateDraftPlanning() {
        this.setState({
            loadingDraftTrips: true
        }, () => {
            let selectedProvider = '';
            if (this.context.selectedProvider !== undefined) {
                selectedProvider = this.context.selectedProvider.split(':')[0];
            }

            this.countTripsDraft(this.context.edition, selectedProvider);
        });
    }

    getStops(edition, provider = '') {
        StopAPI.list(edition.network, provider)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loadingActiveStops: false,
                    activeStops: data,
                    activeStopsCount: data.length,
                }, () => {
                    this.stopConverter();
                });
            }).catch((err) => {
                this.setState({
                    loadingActiveStops: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    getStopsDraft(edition, provider = '') {
        StopAPI.listDraft(edition.draftNetwork, provider)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loadingDraftStops: false,
                    draftStops: data,
                    draftStopsCount: data.length,
                }, () => {
                    this.stopConverterDraft();
                });
            }).catch((err) => {
                this.setState({
                    loadingDraftStops: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    getLines(edition, provider = '') {
        LineAPI.list(edition.network, provider)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loadingActiveLines: false,
                    activeLines: data,
                });
            }).catch((err) => {
                this.setState({
                    loadingActiveLines: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    getLinesDraft(edition, provider = '') {
        LineAPI.listDraft(edition.draftNetwork, provider)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loadingDraftLines: false,
                    draftLines: data,
                });
            }).catch((err) => {
                this.setState({
                    loadingDraftLines: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    getPaths(edition, provider = '') {
        PathAPI.list(edition.network, provider)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loadingActivePaths: false,
                    activePaths: data,
                    activePathsCount: data.length
                }, () => {
                    this.createTrips();
                });
            }).catch((err) => {
                this.setState({
                    loadingActivePaths: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    
    getPathsDraft(edition, provider = '') {
        PathAPI.listDraft(edition.draftNetwork, provider)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loadingDraftPaths: false,
                    draftPaths: data,
                    draftPathsCount: data.length
                }, () => {
                    this.createTripsDraft();
                });
            }).catch((err) => {
                this.setState({
                    loadingDraftPaths: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    countLines(edition, provider = '') {
        LineAPI.countActive(edition.network, provider)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loadingActiveLines: false,
                    activeLinesCount: undefined !== data.count ? data.count : 0
                });
            }).catch((err) => {
                this.setState({
                    loadingActiveLines: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    countTrips(edition, provider = '') {
        TripAPI.countActive(edition.network, edition.planning, provider)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loadingActiveTrips: false,
                    activeTripsCount: undefined !== data.count ? data.count : 0
                });
            }).catch((err) => {
                this.setState({
                    loadingActiveTrips: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    countTripsDraft(edition, provider = '') {
        TripAPI.countDraft(edition.network, edition.draftNetwork, edition.draftPlanning, provider)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loadingDraftTrips: false,
                    draftTripsCount: undefined !== data.count ? data.count : 0
                });
            }).catch((err) => {
                this.setState({
                    loadingDraftTrips: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    countLinesDraft(edition, provider = '') {
        LineAPI.countDraft(edition.draftNetwork, provider)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loadingDraftLines: false,
                    draftLinesCount: undefined !== data.count ? data.count : 0
                });
            }).catch((err) => {
                this.setState({
                    loadingDraftLines: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    // ----------------------
    getDraftPathStops(edition, provider = '') {
        PathStopAPI.listDraft(edition.draftNetwork, provider)
            .then(response => JSON.parse(response))
            .then(data => {
                this.setState({
                    loadingDraft: false,
                    draftPathStops: data
                }, () => { this.createDraftMap(); });
            }).catch((err) => {
                this.setState({
                    loadingDraft: false,
                    alertTitle: "Erro",
                    alertMessage: err.message,
                    alertStyle: 'danger',
                    icon: 'remove',
                    showErrorModal: true
                });
            });
    }

    stopConverter = () => {
        const { activeStops, activeStopsCount } = this.state;
        const stopsM = [];

        if (0 < activeStopsCount) {
            activeStops.forEach((stop) => {
                if (undefined === stopsM.find(s => s.id === stop.id)) {
                    stopsM.push({
                        id: stop.id,
                        code: stop.code,
                        name: stop.name,
                        latitude: stop.latitude,
                        longitude: stop.longitude,
                        position: [stop.latitude, stop.longitude],
                    });
                }
            });
        }

        this.setState({
            activeMapStops: stopsM,
            availableActiveStops: stopsM
        });
    }

    stopConverterDraft = () => {
        const { draftStops, draftStopsCount } = this.state;
        const stopsM = [];

        if (0 < draftStopsCount) {
            draftStops.forEach((stop) => {
                if (undefined === stopsM.find(s => s.id === stop.id)) {
                    stopsM.push({
                        id: stop.id,
                        code: stop.code,
                        name: stop.name,
                        latitude: stop.latitude,
                        longitude: stop.longitude,
                        position: [stop.latitude, stop.longitude],
                    });
                }
            });
        }

        this.setState({
            draftMapStops: stopsM,
            availableDraftStops: stopsM
        });
    }

    createTrips = () => {
        const { activePaths, activePathsCount } = this.state;

        const tripsM = [];
        const defaultLineColor = "rgba(0,0,0,1)";

        if (0 < activePathsCount) {
            activePaths.forEach((path) => {
                if (undefined === path.pathStops || 0 === path.pathStops.length) {
                    return;
                }

                path.pathStops.sort((a, b) => a.stopOrder - b.stopOrder);
                path.pathStops.forEach((stop, i) => {
                    if (path.pathStops[i + 1] !== undefined) {
                        tripsM.push({
                            id: path.id,
                            code: path.code,
                            originID: stop.stop.id,
                            origin: [stop.stop.latitude, stop.stop.longitude],
                            destination: [path.pathStops[i + 1].stop.latitude, path.pathStops[i + 1].stop.longitude],
                            destinationID: path.pathStops[i + 1].stop.id,
                            pathStops: path.pathStops,
                            shape: path.shape,
                            orientation: path.orientation,
                            lineCode: path.line.code,
                            lineColor: undefined === path.line.lineColor ?
                                defaultLineColor :
                                `rgba(${path.line.lineColor.backColor.r},${path.line.lineColor.backColor.g},${path.line.lineColor.backColor.b},${path.line.lineColor.backColor.a})`
                        });
                    }
                });
            });
        }

        this.setState({
            activeMapPaths: tripsM,
            availableActivePaths: tripsM,
        });
    }

    createTripsDraft = () => {
        const { draftPaths, draftPathsCount } = this.state;

        const tripsM = [];
        const defaultLineColor = "rgba(0,0,0,1)";

        if (0 < draftPathsCount) {
            draftPaths.forEach((path) => {
                if (undefined === path.pathStops || 0 === path.pathStops.length) {
                    return;
                }

                path.pathStops.sort((a, b) => a.stopOrder - b.stopOrder);
                path.pathStops.forEach((stop, i) => {
                    if (path.pathStops[i + 1] !== undefined) {

                        const exists = tripsM.some(trip => trip.id === path.id);
                        if(!exists) {
                            tripsM.push({
                                id: path.id,
                                code: path.code,
                                originID: stop.stop.id,
                                origin: [stop.stop.latitude, stop.stop.longitude],
                                destination: [path.pathStops[i + 1].stop.latitude, path.pathStops[i + 1].stop.longitude],
                                destinationID: path.pathStops[i + 1].stop.id,
                                pathStops: path.pathStops,
                                shape: path.shape,
                                lineId: path.lineId,
                                lineCode: path.lineCode,
                                lineColor: undefined === path.lineColor ?
                                    defaultLineColor :
                                    `rgba(${path.lineColor.backColor.r},${path.lineColor.backColor.g},${path.lineColor.backColor.b},${path.lineColor.backColor.a})`
                            });
                        }
                    }
                });
            });
        }

        this.setState({
            draftMapPaths: tripsM,
            availableDraftPaths: tripsM,
        });
    }
    
    createDraftMap = () => {
        const { draftPathStops } = this.state;
        let draftMapPaths = [];
        let draftMapStops = [];

        draftPathStops.sort(function (a, b) {
            return a.pathId - b.pathId || a.stopOrder - b.stopOrder;
        });

        let lastPathId = undefined;
        let prevPathStop = undefined;
        const defaultLineColor = "rgba(0,0,0,1)";

        draftPathStops.forEach((pathStop) => {
            if (undefined === draftMapStops.find(stop => stop.id === pathStop.stopId)) {
                draftMapStops.push({
                    id: pathStop.stopId,
                    code: pathStop.stopCode,
                    name: pathStop.stopName,
                    latitude: pathStop.stopLatitude,
                    longitude: pathStop.stopLongitude,
                    position: [pathStop.stopLatitude, pathStop.stopLongitude]
                });
            }

            if (pathStop.pathId !== lastPathId) {
                lastPathId = pathStop.pathId;
            }
            else {
                draftMapPaths.push({
                    originID: prevPathStop.stopId,
                    origin: [prevPathStop.stopLatitude, prevPathStop.stopLongitude],
                    destinationID: pathStop.stopId,
                    destination: [pathStop.stopLatitude, pathStop.stopLongitude],
                    lineColor: undefined === pathStop.lineBackColor ?
                        defaultLineColor :
                        `rgba(${pathStop.lineBackColor.r},${pathStop.lineBackColor.g},${pathStop.lineBackColor.b},${pathStop.lineBackColor.a})`,
                });
            }

            prevPathStop = pathStop;
        });

        this.setState({
            draftMapStops: draftMapStops,
            availableDraftStops: draftMapStops,
            draftStopsCount: draftMapStops.length,
            draftMapPaths: draftMapPaths,
            availableDraftPaths: draftMapPaths,
            draftPathsCount: draftMapPaths.length
        });
    }

    clearError = () => {
        this.setState({
            showErrorModal: false
        });
    }

    // ----------------

    getAddOns() {
        const { commands, actions } = this.state;
        actions.isLoadingAddOns = true;
        commands.addOns.get(
            (a) => this.addOnsSuccessCallback(a),
            () => this.addOnsErrorCallback()
        );
    }

    addOnsSuccessCallback(result) {
        const { actions } = this.state;

        actions.isLoadingAddOns = false;

        this.setState({
            addOns: result,
            actions: actions
        });
    }

    addOnsErrorCallback() {
        const { actions } = this.state;

        actions.isLoadingAddOns = false;

        this.setState({
            actions: actions
        });
    }

    onExecuteAddOn(addOn, label, parameters = undefined) {
        const { commands, actions, render } = this.state;

        render.addOn = label;
        actions.isExecutingAddOn = true;
        commands.addOns.execute(
            addOn,
            label,
            parameters,
            (a) => this.operationSuccessCallback(a, "isExecutingAddOn", false),
            (a) => this.operationErrorCallback(a, "isExecutingAddOn")
        );

        this.setState({
            actions: actions,
            render: render
        });
    }

    operationSuccessCallback(messageReceived, updateAction, callback = undefined) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        if ("function" === typeof callback) {
            callback();
        }
    }

    operationErrorCallback(messageReceived, updateAction) {
        const { actions, message } = this.state;

        actions[updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }


        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    onHideForm() {
        const { form } = this.state;

        form.showNameForm = false;

        this.setState({
            form: form
        });
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    getUniqueStops(paths) {
        const { isActiveNetwork, activeMapStops, draftMapStops } = this.state;

        if(isActiveNetwork) {
            return activeMapStops.filter(stop =>
                paths.some(path =>
                    path.pathStops.some(pathStop => pathStop.stop.id === stop.id)
                )
            );
        }

        return draftMapStops.filter(stop =>
            paths.some(path =>
                path.pathStops.some(pathStop => pathStop.stop.id === stop.id)
            )
        );
    };

    // ----------------
    handlePathChange(selectedOption) {
        const { isActiveNetwork, activeMapPaths, availablePathsDraft, availablePathsActive, selectedActiveLines, selectedDraftLines, draftMapPaths } = this.state;

        const mapPaths = isActiveNetwork ? activeMapPaths : draftMapPaths;
        const availablePaths = isActiveNetwork ? availablePathsActive : availablePathsDraft;
        const selectedLines = isActiveNetwork ? selectedActiveLines : selectedDraftLines;

        if (!selectedOption || selectedOption.length === 0) {
            const filteredPaths = mapPaths.filter(path =>
                isActiveNetwork ?
                    selectedLines.some(line => line.paths.some(linePath => linePath.id === path.id)) :
                    selectedLines.some(line => line.pathIds.some(id => id === path.id))
            );

            if(isActiveNetwork) {
                this.setState({
                    selectedActivePaths: [],
                    availableActivePaths: filteredPaths,
                    availableActiveStops: this.getUniqueStops(filteredPaths),
                });
            }
            else {
                this.setState({
                    selectedDraftPaths: [],
                    availableDraftPaths: filteredPaths,
                    availableDraftStops: this.getUniqueStops(filteredPaths),
                });
            }
            return;
        }

        const selectedPaths = availablePaths.filter(path =>
            selectedOption.some(option => parseInt(option.value, 10) === path.id)
        );

        const filteredPaths = mapPaths.filter(path =>
            selectedPaths.some(selectedPath => selectedPath.id === path.id)
        );


        if(isActiveNetwork) {
            this.setState({
                selectedActivePaths: selectedPaths,
                availableActivePaths: filteredPaths,
                availableActiveStops: this.getUniqueStops(filteredPaths),
            });
        }
        else {
            this.setState({
                selectedDraftPaths: selectedPaths,
                availableDraftPaths: filteredPaths,
                availableDraftStops: this.getUniqueStops(filteredPaths),
            });
        }
    }

    handleLineChange(selectedOption) {
        const {
            isActiveNetwork,
            activeLines,
            draftLines,
            activeMapPaths,
            activeMapStops,
            draftMapStops,
            draftMapPaths,
            selectedActivePaths,
            selectedDraftPaths
        } = this.state;

        if (!selectedOption || selectedOption.length === 0) {
            if(isActiveNetwork) {
                this.setState({
                    selectedActiveLines: [],
                    availablePathsActive: [],
                    selectedActivePaths: [],
                    availableActiveStops: activeMapStops,
                    availableActivePaths: activeMapPaths,
                });
            }
            else {
                this.setState({
                    selectedDraftLines: [],
                    availablePathsDraft: [],
                    selectedDraftPaths: [],
                    availableDraftStops: draftMapStops,
                    availableDraftPaths: draftMapPaths,
                });
            }
            return;
        }

        const availableLines = isActiveNetwork ? activeLines : draftLines;
        const selectedPaths = isActiveNetwork ? selectedActivePaths : selectedDraftPaths;

        const selectedLineIds = selectedOption.map(option => parseInt(option.value, 10));
        const selectedLines = availableLines.filter(line => selectedLineIds.includes(line.id));

        const availablePaths = isActiveNetwork ? selectedLines.flatMap(line => line.paths || []) : 
            draftMapPaths.filter(path => selectedLines.some(line => line.pathIds.some(pathId => pathId === path.id)));

        const filteredSelectedPaths = selectedPaths.filter(path =>
            availablePaths.some(availablePath => availablePath.id === path.id)
        ); 

        let updatedMapPaths = isActiveNetwork
            ? activeMapPaths.filter(path => selectedLines.some(line => line.paths.some(linePath => linePath.id === path.id)))
            : draftMapPaths.filter(path => selectedLines.some(line => line.id === path.lineId)
        );

        if (filteredSelectedPaths.length > 0) {
            updatedMapPaths = updatedMapPaths.filter(path =>
                filteredSelectedPaths.some(selectedPath => selectedPath.code === path.code)
            );
        }

        const uniqueStops = updatedMapPaths.flatMap(path => 
            (path.pathStops || []).map(pathStop => ({
                ...pathStop.stop,
                position: [pathStop.stop.latitude, pathStop.stop.longitude],
                pathId: path.id
            }))
        ).filter((stop, index, self) =>
            self.findIndex(existingStop => existingStop.id === stop.id) === index
        );

        if(isActiveNetwork) {
            this.setState({
                selectedActiveLines: selectedLines,
                availablePathsActive: availablePaths,
                selectedActivePaths: filteredSelectedPaths,
                availableActiveStops: uniqueStops,
                availableActivePaths: updatedMapPaths,
            });
        }
        else {
            this.setState({
                selectedDraftLines: selectedLines,
                availablePathsDraft: availablePaths,
                selectedDraftPaths: filteredSelectedPaths,
                availableDraftStops: uniqueStops,
                availableDraftPaths: updatedMapPaths,
            });
        }
    }

    handleEditionSwitch() {
        this.setState({
            isActiveNetwork: !this.state.isActiveNetwork,
        });
    }

    handleCheckboxToggle() {
        const { isActiveNetwork } = this.state;
        if(isActiveNetwork) {
            this.setState({
                showStopsActive: !this.state.showStopsActive
            });
        }
        else {
            this.setState({
                showStopsDraft: !this.state.showStopsDraft
            });
        }
    }

    renderLines() {
        const { isActiveNetwork, activeLines, draftLines, selectedActiveLines, selectedDraftLines} = this.state;

        const linesToDisplay = isActiveNetwork ? activeLines : draftLines;
        const selectedLines = isActiveNetwork ? selectedActiveLines : selectedDraftLines;

        return(
            <Select
                className="custom-multiselect"
                placeholder="Selecione uma ou mais linhas..."
                value={
                    selectedLines === undefined || selectedLines.length === 0
                        ? ""
                        : selectedLines.map((l) => {
                            const line = linesToDisplay.find((line) => line.id === l.id);
                            return line ? { value: line.id, label: `${line.code} | ${line.goName}` } : null;
                        }).filter(Boolean)
                }
                isMulti={true}
                onChange={(e) => this.handleLineChange(e)}
                options={
                    linesToDisplay
                        .filter((line) =>
                            !selectedLines.some((selected) => selected.id === line.id)
                        )
                        .sort((a, b) => {
                            const extractParts = (code) => {
                                const match = code.match(/^(\d+)([A-Za-z]*)$/);
                                return match ? [parseInt(match[1], 10), match[2]] : [0, ""];
                            };

                            const [numA, suffixA] = extractParts(a.code);
                            const [numB, suffixB] = extractParts(b.code);

                            return numA !== numB ? numA - numB : suffixA.localeCompare(suffixB);
                        })
                        .map((line) => ({
                            value: `${line.id}`,
                            label: `${line.code} | ${line.goName}`,
                        }))
                }
            />
        );
    }

    renderPaths() {
        const {selectedActivePaths, selectedDraftPaths, availablePathsActive, availablePathsDraft, activePaths, draftPaths, isActiveNetwork} = this.state;

        const pathsToDisplay = isActiveNetwork ? activePaths : draftPaths;
        const selectedPaths = isActiveNetwork ? selectedActivePaths : selectedDraftPaths;
        const availablePaths = isActiveNetwork ? availablePathsActive : availablePathsDraft;

        return(
            <Select
                className="custom-multiselect"
                placeholder="Selecione um ou mais percursos..."
                value={
                    selectedPaths === undefined || selectedPaths.length === 0 
                        ? "" 
                        : selectedPaths.map((p) => {
                            const path = pathsToDisplay.find((path) => p.id === path.id);
                            return path ? { value: path.id, label: `${path.code}`} : null;
                        }).filter(Boolean)
                }
                isMulti={true}
                onChange={(e) => this.handlePathChange(e)}
                options={
                    availablePaths
                        .filter((path) => 
                            !selectedPaths.some((selected) => selected.id === path.id)
                        )
                        .sort((a, b) => (a.code !== b.code ? (a.code < b.code ? -1 : 1) : 0))
                        .map((path) => ({
                            value: `${path.id}`,
                            label: `${path.code}`
                        }))
                }
            />
        );
    }

    renderMap() {
        const { loadingActiveLines, loadingActiveStops, loadingActivePaths, loadingActiveTrips } = this.state;
        const { loadingDraftLines, loadingDraftStops, loadingDraftPaths, loadingDraftTrips } = this.state;

        if (loadingActiveLines || loadingActiveStops || loadingActivePaths || loadingActiveTrips ||
                loadingDraftLines || loadingDraftStops || loadingDraftPaths || loadingDraftTrips) {
            return (<LoadingSpinner />);
        }

        const { availableActivePaths, availableActiveStops, availableDraftPaths, availableDraftStops } = this.state;
        const { activeStopsCount, activePathsCount, activeLinesCount, activeTripsCount } = this.state;
        const { draftStopsCount, draftPathsCount, draftLinesCount, draftTripsCount, showStopsActive, showStopsDraft } = this.state;

        const {isActiveNetwork } = this.state;

        const mapPaths = isActiveNetwork ? availableActivePaths : availableDraftPaths;
        const mapStops = isActiveNetwork ? availableActiveStops : availableDraftStops;
        const showStops = isActiveNetwork ? showStopsActive : showStopsDraft;

        return (
            <Grid fluid className="dashboard margin-top-15">
                <Row className="margin-top-5">
                    <div className="network-toggle-container">
                        <span className={`network-text ${isActiveNetwork ? "active" : ""}`}>Rede Ativa</span>
                        <div className={`custom-toggle ${isActiveNetwork ? "inactive" : "active"}`} onClick={() => this.handleEditionSwitch()}>
                            <div className="slider" />
                        </div>
                        <span className={`network-text ${isActiveNetwork ? "" : "active"}`}>Rede Rascunho</span>
                    </div>
                </Row>
                <Row className="margin-top-5">
                    <Col sm={3}>
                        <Label className="panel-labels panel-label-title">TOTAL PARAGENS</Label>
                        <Label className="panel-labels panel-label-data">
                            <span>{isActiveNetwork ? (activeStopsCount !== undefined ? activeStopsCount : 0) : (draftStopsCount !== undefined ? draftStopsCount : 0)}</span>
                        </Label>
                    </Col>
                    <Col sm={3}>
                        <Label className="panel-labels panel-label-title">TOTAL PERCURSOS</Label>
                        <Label className="panel-labels panel-label-data">
                            <span>{isActiveNetwork ? (activePathsCount !== undefined ? activePathsCount : 0) : (draftPathsCount !== undefined ? draftPathsCount : 0)}</span>
                        </Label>
                    </Col>
                    <Col sm={3}>
                        <Label className="panel-labels panel-label-title">TOTAL LINHAS</Label>
                        <Label className="panel-labels panel-label-data">
                            <span>{isActiveNetwork ? (activeLinesCount !== undefined ? activeLinesCount : 0) : (draftLinesCount !== undefined ? draftLinesCount : 0)}</span>
                        </Label>
                    </Col>
                    <Col sm={3}>
                        <Label className="panel-labels panel-label-title">TOTAL VIAGENS</Label>
                        <Label className="panel-labels panel-label-data">
                            <span>{isActiveNetwork ? (activeTripsCount !== undefined ? activeTripsCount : 0) : (draftTripsCount !== undefined ? draftTripsCount : 0)}</span>
                        </Label>
                    </Col>
                </Row>
                <Row className="margin-top-25">
                    <Col sm={9}>
                        <DashboardMap mapStops={mapStops}
                            mapPaths={mapPaths}
                            showStops={showStops}/>
                    </Col>
                    <Col sm={3} className="text-left">
                        <Row className="margin-top-5">
                            <FormGroup className="form-group-dashboard">
                                <ControlLabel>Linha</ControlLabel>
                                {this.renderLines()}
                            </FormGroup>
                        </Row>
                        <Row className="margin-top-5">
                            <FormGroup className="form-group-dashboard">
                                <ControlLabel>Percursos</ControlLabel>
                                {this.renderPaths()}
                            </FormGroup>
                        </Row>
                        <Row className="margin-top-5">
                            <FormGroup className="form-group-dashboard">
                                <Checkbox 
                                    className="form-checkbox"
                                    checked={showStops}
                                    onChange={() => this.handleCheckboxToggle()}>
                                    Mostrar Paragens
                                </Checkbox>
                            </FormGroup>
                        </Row>
                    </Col>
                </Row>
            </Grid>
        );
    }

    renderOpenWebsiteAddOn() {
        const { addOns, actions } = this.state;

        if (!Array.isArray(addOns)) {
            return null;
        }

        const addOn = addOns.find(addOn => addOn.enabled && "UpdateWebsite" === addOn.name);
        if (undefined === addOn) {
            return null;
        }

        return (
            <Button onClick={() => this.onExecuteAddOn(addOn.name, addOn.label, undefined)} disabled={actions.isExecutingAddOn}>{addOn.label}</Button>
        )
    }

    handleToggle() {
        const { isActiveNetwork } = this.state; 

        this.setState({
            isActiveNetwork: !isActiveNetwork
        });
    }

    render() {
        const { actions, render, message} = this.state;
        return (
            <div>
                <EditionSelector />

                <TitleRow title="Quadro de Análise" showSeparator={true}>
                    <Col className="pull-right margin-right-negative-11" sm={16}>
                        {this.renderOpenWebsiteAddOn()}
                    </Col>
                </TitleRow>

                <Panel bsStyle="info" className="custom-panel">
                    <Panel.Body className="text-center">
                        {this.renderMap()}
                    </Panel.Body>
                </Panel>

                <HandleMessage title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    icon={this.state.icon}
                    style={this.state.alertStyle}
                    show={this.state.showErrorModal}
                    onHide={this.clearError} />

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleMessage
                    title={`A ${render.addOn}`}
                    message={<LoadingSpinner />}
                    style={`primary`}
                    icon={this.state.icon}
                    show={actions.isExecutingAddOn}
                    small
                    noButtons />
            </div>
        )
    }
}
